import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const COMPANY = content.company || {};
  return (
    <footer className="border-t border-border bg-card" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="mb-4">
            <img
              src="/logo.png"
              alt="Runner Trade Park Limited"
              className="h-[115px] w-auto rounded-lg bg-white p-1.5"
            />
          </div>
          <p className="text-sm leading-relaxed text-muted-foreground" data-testid="footer-text">
            {COMPANY.footerText || `${COMPANY.tagline || ""} Exclusive distributor of Eurogrip tyres and Bajaj lubricants since ${COMPANY.established || "2018"}.`}
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold uppercase tracking-[0.2em] text-foreground">
            Explore
          </h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/products" className="hover:text-primary">Products</Link></li>
            <li><Link to="/brands" className="hover:text-primary">Partner Brands</Link></li>
            <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
            <li><Link to="/dealer-network" className="hover:text-primary">Dealer Network</Link></li>
            <li><Link to="/news" className="hover:text-primary">News &amp; Events</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold uppercase tracking-[0.2em] text-foreground">
            Support
          </h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/support" className="hover:text-primary">Contact & Support</Link></li>
            <li><Link to="/support" className="hover:text-primary">Become a Dealer</Link></li>
            <li><Link to="/support" className="hover:text-primary">Warranty Claims</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold uppercase tracking-[0.2em] text-foreground">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="h-4 w-4 shrink-0 text-primary" />
              <span>{COMPANY.phone}</span>
            </li>
            <li className="flex gap-3">
              <Mail className="h-4 w-4 shrink-0 text-primary" />
              <span>{COMPANY.email}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-muted-foreground sm:flex-row sm:px-6 lg:px-8">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span className="uppercase tracking-[0.2em]">{COMPANY.tagline}</span>
        </div>
      </div>
    </footer>
  );
};
